// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bel_a bhi_tp","StrollerBoxWidget__imageCounselling":"bel_b bhi_ke"};